const DiarySubmenu = ({ menuItems, currentRoute }) => {
    const selected = menuItems.find((item) => item.active_routes.includes(currentRoute)) || menuItems[0]; // Fallback to first item

    const handleSelect = (item) => {
        const target = item.route;
        const current = window.location.pathname;

        if (current === target) return;

        window.location.href = target;
    };

    const orderedMenuItems = [selected, ...menuItems.filter((item) => item.route !== selected.route)];

    return (
        <div className="dropdown diary-submenu-dropdown">
            <button className="toggle-button" type="button" data-toggle="dropdown">
                <span className="left">
                    <img src={selected.icon_path} alt="" /> {selected.label}
                </span>
                <span className="right">
                    <img src="/assets/images/diary-icons/bars.svg" alt="" />
                </span>
            </button>

            <ul className="dropdown-menu">
                {orderedMenuItems.map((item) => (
                    <li
                        key={item.route}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSelect(item);
                        }}
                    >
                        <img src={item.icon_path} alt="" /> {item.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DiarySubmenu;
